import React, { useEffect } from 'react';
import cn from 'classnames';
import { ButtonV3 } from 'components/ComponentV2';
import Gamification, { GamificationProps } from 'pages/company/Gamification';
import styles from './SectionWrapper.module.scss';

export interface SectionWrapperProps extends GamificationProps {
  /** Custom class name */
  className?: string;
  /** Header title */
  title: string;
  /** Header description */
  description: string;
  /** Header details */
  subDetails?: React.ReactNode;
  /** Add Button Label */
  addButtonLabel?: string;
  /** Add handler */
  onAdd?: () => void;
  /** children for content */
  children: React.ReactNode;
  /** Custom class name for content */
  contentClassName?: string;
  hasData?: boolean;
  showProgressBanner: boolean;
  buttonClassName?: string;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  addButtonLabel,
  title,
  description,
  subDetails,
  onAdd,
  children,
  contentClassName,
  hasData,
  progressDetails,
  profileCompletePercent,
  nonCompletedSection,
  handleProfileCompletionButton,
  handleNextButton,
  showNextButton,
  showProgressBanner,
  buttonClassName,
}: SectionWrapperProps) => {
  const [showProgressBannerState, setShowProgressBannerState] =
    React.useState<boolean>(showProgressBanner);

  useEffect(() => {
    if (showProgressBannerState === false)
      setShowProgressBannerState(showProgressBanner);
  }, [showProgressBanner]);
  return (
    <div id={`section_${progressDetails?.id}`}>
      {showProgressBannerState && (
        <Gamification
          profileCompletePercent={profileCompletePercent}
          nonCompletedSection={nonCompletedSection}
          progressDetails={progressDetails}
          handleProfileCompletionButton={() => {
            setShowProgressBannerState(false);
            handleProfileCompletionButton();
          }}
          handleNextButton={() => {
            setShowProgressBannerState(false);
            handleNextButton && handleNextButton();
          }}
          showNextButton={showNextButton}
        />
      )}
      <div className={styles.MainSection}>
        <div className={styles.MainSectionHeader}>
          <p className={styles.MainSectionHeaderTitle}>{title}</p>
          <p className={styles.MainSectionHeaderDescription}>{description}</p>
          {subDetails ? subDetails : null}
        </div>
        <div className={styles.separator} />
        <div className={cn(styles.MainSectionContent, contentClassName)}>
          {children}
          {addButtonLabel ? (
            <ButtonV3
              type="button"
              className={cn(styles.MainSectionAddButton, buttonClassName, {
                [styles.smallButton]: hasData,
              })}
              onClick={onAdd}
              startIcon="plus"
              variant="contained"
              color="secondary"
              borderRadius={hasData ? 8 : 10}
              size={hasData ? 'small' : 'large'}
            >
              {addButtonLabel}
            </ButtonV3>
          ) : null}
        </div>
      </div>
    </div>
  );
};

SectionWrapper.displayName = 'SectionWrapper';
